import { Button, getThemeColor } from '@sparemin/blockhead';
import styled from 'styled-components';

type ToggleStyleProps = {
  $selected: boolean;
};

type OptionsStyleProps = {
  $selectedIndex: number;
};

const toggleWidth = '175px';
const toggleGap = '20px';
const toggleHeight = '30px';
const transitionDuration = '250ms';

export const Group = styled(Button).attrs({
  color: 'tertiary',
  variant: 'ghost',
})`
  border-color: ${getThemeColor('l4')};
  border-width: 1px;
  height: 70px;
  justify-content: center;
  margin-left: auto;
  padding: 20px;
  pointer-events: auto;
`;

export const Options = styled('div')<OptionsStyleProps>`
  align-items: center;
  display: flex;
  gap: ${toggleGap};
  height: 100%;
  position: relative;

  // indicator
  &::before {
    background-color: ${getThemeColor('d4')};
    border-radius: 15px;
    content: '';
    height: ${toggleHeight};
    position: absolute;
    transition: transform ${transitionDuration} ease-in;
    width: ${toggleWidth};
    ${({ $selectedIndex }) => `
    transform: translateX(
    calc((${toggleWidth} * ${$selectedIndex}) + (${toggleGap} * ${$selectedIndex})))`}
  }
`;

export const Toggle = styled('span')<ToggleStyleProps>`
  align-items: center;
  background-color: transparent;
  color: ${({ $selected }) =>
    $selected ? getThemeColor('white') : getThemeColor('d4')};
  display: flex;
  height: ${toggleHeight};
  transition: color ${transitionDuration} ease-in;
  justify-content: center;
  width: ${toggleWidth};
  z-index: 1;
`;
